import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static validQuestionText(): ValidatorFn {
    const hasValidChars = /^[a-zA-Z0-9\s.,!?'"#@+\-:;()]+$/; // allowed characters
    const hasAlphaNumeric = /[a-zA-Z0-9]/; // must contain at least one letter or number
    const onlyNumbers = /^[0-9\s]+$/; // only numbers and spaces

    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      if (!hasValidChars.test(value)) {
        return { invalidQuestionText: true }; // contains disallowed characters
      }

      if (!hasAlphaNumeric.test(value)) {
        return { onlySpecialCharacters: true }; // contains only special characters
      }
	   if (onlyNumbers.test(value)) {
        return { onlyNumbers: true };  // disallow input with only numbers
      }

      return null;
    };
  }
}